<template>
  <div id="app">
    <section class="topSet">
      <nav
        class="navbar navbar-expand-lg navbar-dark dark_info"
        aria-label="Ninth navbar example"
      >
        <div class="container-xl">
          <a class="navbar-brand" href="#">
            <img :src="$t('logo')" alt="" class="logo" />
          </a>

          <button
            class="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarsExample07XL"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="navbar-collapse collapse"
            id="navbarsExample07XL"
            ref="menuDom"
          >
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link
                  to="/"
                  class="nav-link"
                  exact-active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.home') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/solution"
                  class="nav-link"
                  active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.solution') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/service"
                  class="nav-link"
                  active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.service') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/sustainability"
                  class="nav-link"
                  active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.sustainability') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/manufacturers"
                  class="nav-link"
                  active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.manufacturers') }}
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  to="/about"
                  class="nav-link"
                  active-class="active"
                  @click="closeMenu"
                >
                  {{ $t('nav.about') }}
                </router-link>
              </li>
            </ul>

            <ul class="navbar-nav">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  data-bs-toggle="dropdown"
                >
                  {{ $t('language') }}
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                  <li>
                    <a
                      class="dropdown-item"
                      @click="
                        setLang('zh');
                        closeMenu();
                      "
                      >中文</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      @click="
                        setLang('en');
                        closeMenu();
                      "
                      >English</a
                    >
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </section>
    <section style="padding: 60px 0 0 0">
      <router-view />
    </section>
    <section>
      <footerInfo />
    </section>
  </div>
</template>

<script>
import footerInfo from '@/components/footer.vue';

export default {
  components: {
    footerInfo,
  },
  watch: {
    // 路由切换自动关闭
    $route() {
      this.closeMenu();
    },
  },
  methods: {
    setLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },
    closeMenu() {
      // 1.移除展开show类
      const menu = this.$refs.menuDom;
      if (menu) {
        menu.classList.remove('show');
      }
      // 2.给按钮加collapsed，变回三横线图标
      const btn = document.querySelector('.navbar-toggler');
      if (btn) {
        btn.classList.add('collapsed');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  padding: 5px 0 5px 0;
}

.topSet {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
}
.navbar-brand {
  padding: 0;
}
.navbar {
  padding: 0;
  font-size: 14px;
}
.nav-link {
  color: #323131 !important;
  cursor: pointer;
}
.nav-link:hover {
  color: #0099f2 !important;
  opacity: 0.9;
}
.nav-link.active {
  color: #0099f2 !important;
}
.nav-item {
  padding: 5px 10px 0 20px;
}
.dark_info {
  background-color: #fff;
  // border-bottom: solid 1px #ccc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  padding: 10px 0;
}
a {
  font-size: 16px;
}
</style>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%2368aed0' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
}

.navbar-toggler:not(.collapsed) .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%2368aed0' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M6 6L24 24M24 6L6 24'/%3e%3c/svg%3e") !important;
}

@media (max-width: 991px) {
  .container-xxl {
    padding: 0;
  }
  .navbar-nav .nav-item {
    border-bottom: 1px solid #eee !important;
    padding-bottom: 10px !important;
    margin-bottom: 10px !important;
  }
  .navbar-nav .nav-item.dropdown {
    border-bottom: none !important;
    margin-bottom: 0 !important;
  }
}
</style>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
}
</style>
